export default __webpack_public_path__ + "static/media/documents-icons.6c27cee0.zip";